module.exports = __webpack_public_path__ + "img/add-icon.00029e67.svg";